module.exports = __webpack_public_path__ + "img/md-navigate_left.d1723908.svg";